import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useProgram } from '../../contexts/ProgramContext';
import { programsAPI } from '../../services/api';

// Renders in the admin sidebar header. Lists available programs and switches
// the active one — switchProgram() persists to localStorage and the axios
// interceptor sends X-Program on every subsequent admin request.
const ProgramSwitcher = () => {
  const { slug, program, switchProgram } = useProgram();
  const [programs, setPrograms] = useState([]);
  const [open, setOpen] = useState(false);
  const [loadingList, setLoadingList] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoadingList(true);
    programsAPI
      .list()
      .then((res) => {
        if (cancelled) return;
        const list = res.data?.data?.programs || res.data?.data || [];
        setPrograms(Array.isArray(list) ? list : []);
      })
      .catch(() => {
        if (cancelled) return;
        setPrograms([]);
      })
      .finally(() => {
        if (!cancelled) setLoadingList(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const handleSelect = (nextSlug) => {
    setOpen(false);
    if (nextSlug && nextSlug !== slug) switchProgram(nextSlug);
  };

  const label = program?.label || program?.name || slug || 'Programa';

  return (
    <div className="program-switcher">
      <button
        type="button"
        className="program-switcher-trigger"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="program-switcher-label">{label}</span>
        <ChevronDown size={16} />
      </button>
      {open && (
        <ul className="program-switcher-menu" role="listbox">
          {loadingList && <li className="program-switcher-empty">Carregando…</li>}
          {!loadingList && programs.length === 0 && (
            <li className="program-switcher-empty">Nenhum programa disponível</li>
          )}
          {programs.map((p) => (
            <li
              key={p.id || p.slug}
              role="option"
              aria-selected={p.slug === slug}
              className={'program-switcher-item ' + (p.slug === slug ? 'is-active' : '')}
              onClick={() => handleSelect(p.slug)}
            >
              {p.label || p.name || p.slug}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ProgramSwitcher;
